import { getRem, transitionAnimation } from 'lib/core';
import { IconChevronRight } from 'lib/icons';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

export const StyledNestedListItemIcon = styled(IconChevronRight)`
  fill: ${({ theme }) => theme.color.text.light.secondary.value};
  margin-right: ${({ $nestingLevel, $withExtraMargin }) =>
    ($nestingLevel === 1 && $withExtraMargin && getRem('4px')) || ($withExtraMargin && getRem('12px')) || 0};
  min-width: ${getRem('24px')};
  transform: ${({ $isExpanded }) => ($isExpanded ? 'rotate(90deg)' : 'none')};
  ${transitionAnimation('all')}

  ${({ $isDisabled, theme }) =>
    $isDisabled &&
    css`
      fill: ${theme.color.text.light.disabled.value};
    `};
`;

const NestedListItemIcon = ({ isExpanded, nestingLevel, withExtraMargin, ...other }) => (
  <StyledNestedListItemIcon
    $isExpanded={isExpanded}
    $nestingLevel={nestingLevel}
    $withExtraMargin={withExtraMargin}
    {...other}
  />
);

NestedListItemIcon.propTypes = {
  /** If true, rotate the caret 90 degrees */
  isExpanded: PropTypes.bool,
  /** Used to determine the amount of left-hand spacing to use */
  nestingLevel: PropTypes.number,
  /** Used when more padding is needed for icons */
  withExtraMargin: PropTypes.bool,
};

export { NestedListItemIcon };
